import React, { useState } from 'react';
import api from '../../api';
import { useNavigate } from 'react-router-dom';
// 1. Import CSS Module
import styles from './Admin.module.css'; 

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

 
  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
    const response = await api.post('/auth/login', credentials);
      
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', credentials.username);
        navigate('/admin/dashboard'); 
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError("Invalid Username or Password!");
      } else {
        setError("Server Error. Please try again later.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    // 2. Use "adminTheme" for Background but add Flex centering inline for Login Page
    <div className={styles.adminTheme} style={{ justifyContent: 'center', alignItems: 'center' }}>
      
      {/* 3. Reusing "formCard" class for the glassmorphism effect */}
      <div className={styles.formCard} style={{ width: '100%', maxWidth: '400px', padding: '2.5rem' }}>
        
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h2 style={{ color: '#4ade80', marginBottom: '0.5rem', fontWeight: 'bold', fontSize: '1.8rem' }}>
            Rengie Admin
          </h2>
          <p style={{ color: '#94a3b8' }}>Sign in to manage your solar dashboard</p>
        </div>

        {/* Error Message Box (Consistent style) */}
        {error && (
          <div style={{
            padding: '12px', marginBottom: '20px', borderRadius: '8px',
            background: 'rgba(239, 68, 68, 0.15)',
            color: '#fca5a5',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            fontSize: '0.9rem',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label>Username</label>
            <input 
              type="text" 
              name="username" 
              className={styles.formInput}
              placeholder="Enter admin username"
              value={credentials.username}
              onChange={handleChange}
              required 
            />
          </div>

          <div className={styles.formGroup}>
            <label>Password</label>
            <input 
              type="password" 
              name="password" 
              className={styles.formInput}
              placeholder="Enter password"
              value={credentials.password}
              onChange={handleChange}
              required 
            />
          </div>

          <button type="submit" className={styles.primaryBtn} disabled={loading} style={{ marginTop: '1.5rem' }}>
            {loading ? 'Authenticating...' : 'Login Access'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;